import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Enter() {
  const navigate = useNavigate();
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("t");
    if (token) {
      // Exchange the emailed token for an httpOnly cookie — never store it in the browser.
      axios.post(`${API}/access/adopt`, { token })
        .then(() => navigate("/sundaybuilder", { replace: true }))
        .catch(() => navigate("/member-login", { replace: true }));
    } else {
      navigate("/login", { replace: true });
    }
  }, [navigate]);
  return null;
}
